import EnumExtension from "./enum-extensions";

export class StatusNames extends EnumExtension {
  static readonly Enabled = new StatusNames("Enabled");
  static readonly Disabled = new StatusNames("Disabled");
}

export class ShiftStatus extends EnumExtension {
  static readonly Open = new ShiftStatus("Open");
  static readonly Confirmed = new ShiftStatus("Confirmed");
  static readonly Pending = new ShiftStatus("Pending");
  static readonly Ungrouped = new ShiftStatus("Ungrouped");
  static readonly Removed = new ShiftStatus("Removed");
  static readonly Expired = new ShiftStatus("Job Post Expired - No Requests");
  // Need to fix in database, this status should not be assigned to shift.
  static readonly ExpiredV2 = new ShiftStatus("Job Post Expired - No Requests V2");
  static readonly Requested = new ShiftStatus("Requested");
}

export class ResponseStatus extends EnumExtension {
  static readonly Requested = new ResponseStatus("Requested");
  static readonly Accepted = new ResponseStatus("Accepted");
  static readonly Confirmed = new ResponseStatus("Confirmed");
  static readonly NotSelected = new ResponseStatus("Not Selecteed");
  static readonly Expired = new ResponseStatus("Time Expired");
  static readonly Cancelled = new ResponseStatus("Cancelled");
  static readonly ConfirmedDifferent = new ResponseStatus("Confirmed Different JP");
  static readonly NoShow = new ResponseStatus("No Show");
  static readonly PracticeDeleted = new ResponseStatus("Practice Deleted Post");
  static readonly DtDeleted = new ResponseStatus("DA Deleted Account");
  static readonly RunningLate = new ResponseStatus("RunningLate");
}

export class RatingStatus extends EnumExtension {
  static readonly Open = new RatingStatus("Open");
  static readonly Active = new RatingStatus("Active");
  static readonly Dismissed = new RatingStatus("Dismissed");
}

export class Position extends EnumExtension {
  static readonly DentalHygienist = new Position("Dental Hygienist");
}

export class SubscriptionStatus extends EnumExtension {
  static readonly Active = new SubscriptionStatus("Active");
  static readonly TrialingEnded = new SubscriptionStatus("TrialingEnded");
  static readonly CardExpired = new SubscriptionStatus("CardExpired");
  static readonly Trialing = new SubscriptionStatus("Trialing");
}